import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { Text } from "../../FormControls/Text";
import { Stack } from "../../FormControls/Stack";
import { ScreenControl } from "../ScreenControl";
import {
  setPayment,
  generateQuotation,
  setExRateCrypto,
  setExRateCountry,
  setCommission,
  setFiatRecibe,
  setCommissionKiosco,
  setCommissionBank,
  setCommissionAtm,
  setQrTransaction,
  setCommissionPos,
  setCurrency,
  setIdTransaction,
  setTotalDeposit,
  setButtonEnabled,
  setReference,
  setStaticFee,
  recibeQuotWld
} from "../../../../main/slices/transactionSlice";
import { jump } from "../../../../main/slices/routerSlice";
import { Keypad } from "../../FormControls/keypad";
import { AlertBox } from "../../FormControls/alert";
import { AlertSelectBox } from "../../FormControls/SelectAlert";
// import { MiniKit } from "@worldcoin/minikit-js";
import { FloatingButton } from "../../FormControls/Floating";
import { Report } from "@mui/icons-material";
import {
  setPos,
  setGroup,
  setStoreName,
  setCountrySrore,
  setCurrencyStore,
  setIdStore,
  createInvoice,
} from "../../../../main/slices/storeSlice";

const InfoTransaction = ({ children, trx, user, handleScreenControl, changeButtonState, submitTransaction }) => {
  return (
    <Fragment>
      {/* LEGEND */}
      {children}

      <Stack
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center" 
        }}

        flex={{
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "Column",
        }}
      >
        {(parseFloat(trx.amount.value) < 2 && trx.amount.value != "") && user.country.value == "CR" ? (
          <Text
            classes={["description", "alignContent", "error"]}
            style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
          >
            <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
            El monto minimo de venta es de 2 WLD{" "}
          </Text>
        ) : (
          <Text></Text>
        )}
        {/* KEYPAD TO ENTER AMOUNT AND MAKE QUOTATION */}
        <Keypad
          children={
          <ScreenControl
            showGoBack={false}
            index={{...handleScreenControl()}}
            btncolor={"cobrarBtn"}
            btnText={"COBRAR"}
            
            icon= {null}
            disabled={
              user.country.value == "CR"
                ? changeButtonState
                : !trx.buttonEnabled
            }
            beforeSubmit={() => submitTransaction()}
          ></ScreenControl> 
          }
        />
        
        {/* {typeKeypad} */}

        {
          //ERROR  ALERT
          trx.payment.error && trx.payment.value && (
            <Text
              classes={["description", "alignContent", "error"]}
              style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
            >
              <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
              Ocurrio un error con la transaccion, vuelve a intentarlo.
            </Text>
          )
        }
      </Stack>
    </Fragment>
  );
};

export const FormPAD = ({ path }) => {
  const user = useSelector(({ user }) => user);
  const store = useSelector(({ store }) => store);
  const currency = useSelector(({ store }) => store.currency.value);
  const stateTrx = useSelector(({ transaction }) => transaction);
  const [cookies, setCookies, removeCookie] = useCookies();
  const [quoteData, setQuoteData] = useState(null);
  const [errorTrx, setErrorTrx] = useState(false);
  const [amount, setAmount] = useState("");
  const dispatch = useDispatch();

  // ALERT
  const [showAlert, setShowAlert] = useState(false); // view alert
  const [showCloseAlert, setShowCloseAlert] = useState(false); // view alert
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [alertTitle, setAlertTitle] = useState(null);

  let label = (
    <Text classes={["subtitle"]}>
      Ingresa la cantidad de <strong>Worldcoins</strong> que deseas canjear por
      dinero
    </Text>
  );
  let typeKeypad = <Keypad />;

  // ACTIVAR BOTON INICIO SESION
    const getQuotRecibe = async () => {
      return await dispatch(recibeQuotWld({}))
        .unwrap()
        .then(async ({ response }) => {
          if (response.error===false) {
            let fiat = response.price
            dispatch(setFiatRecibe({ value: fiat, error: false }));

          }else {
            //MUESTRO ERROR
            dispatch(setFiatRecibe({ value: 6.20, error: false }));
          };
        })
        .catch(e => {
          //ERROR DE SERVER
          dispatch(setFiatRecibe({ value: 6.20, error: false }));
        });
    }

  //---> Función para actualizar la comisión;
  const UpdateComissionFee = () => {
    dispatch(generateQuotation({ currency: currency }))
      .unwrap()
      .then(({ response, statusCode }) => {
        if (statusCode === 200) {
          setQuoteData(response); // Almacena la cotización en el estado local.
          dispatch(
            setCommission({
              value: response.CommissionPercentage,
              error: false,
            })
          );
          dispatch(
            setExRateCrypto({
              value: parseFloat(response.ExchangeRateCrypto),
              error: false,
            })
          );
          dispatch(
            setExRateCountry({
              value: parseFloat(response.ExchangeRateCountry),
              error: false,
            })
          );
          dispatch(setStaticFee({ value: response.StaticFee, error: false }));
          // SET COMMISSION FOR OPERATIONS
          dispatch(setCommissionBank({ value: response.CommissionBank, error: false }));
          dispatch(setCommissionAtm({ value: response.CommissionAtm, error: false }));
          dispatch(setCommissionPos({ value: response.CommissionPos, error: false }));
          dispatch(setCommissionKiosco({ value: response.CommissionKiosco, error: false }));
        }
      })
      .catch((e) => false);
  };

  useEffect(() => {
    // MiniKit.install();
    dispatch(setCurrency({ value: currency, error: !currency }));
    // RESET TO DEFAULT VALUES TO AVOID ERRORS
    dispatch(setTotalDeposit({ value: 0, error: true }));
    dispatch(setPayment({ value: false, error: true }));
    dispatch(setReference({ value: "", error: true }));
    dispatch(setIdTransaction({ value: "", error: true }));
    dispatch(setButtonEnabled(false));
    UpdateComissionFee();
    getQuotRecibe();

    const intervalId = setInterval(() => {
      UpdateComissionFee();
    }, 15000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  const submitTransaction = async () => {
    if(stateTrx.amount.value<0.10){
      setAlertType('error');
      setAlertMessage(`El monto minimo de compra es de 0.10 centavos.`);
      setErrorTrx(true);
      setShowAlert(true);
    }else{
      if (store) return await dispatch(createInvoice({
        "amountWLD": stateTrx.total.value, 
        "amountLocal": stateTrx.amount.value,
        "store": `${store.idStore.value}`,
        "localCurrency": `${store.currency.value}`
      })).unwrap()
          .then(({ response }) => {
            let qr= response.data.qrUrl;
            let idTrx= response.data.trxId;
            if (response.code==200) {
              setErrorTrx(false);
              dispatch(setQrTransaction({ value: qr, error: false }));
              dispatch(setIdTransaction({ value: idTrx, error: false }));
              return true;
            }else if(response.code==201){
              setAlertType('error');
              setAlertMessage(`No es posible crear la transacción en este momento, intentalo nuevamente más tarde.`);
              setErrorTrx(true);
              setShowAlert(true);
              return true
            }else {
              setAlertType('error');
              setAlertMessage(`Error inesperado, intentalo nuevamente más tarde.`);
              setErrorTrx(true);
              setShowAlert(true);
              return false
            };
          })
          .catch(e => {
            setAlertType('error');
            setAlertMessage(`Error inesperado, intentalo nuevamente más tarde.`);
            setErrorTrx(true);
            setShowAlert(true);
            return false
          });

      else {
        setAlertType('error');
        setAlertMessage(`Error Server.`);
        setErrorTrx(true);
        setShowAlert(true);
        return false;
      }
    }
  };

  const changeButtonState = () => {
    const amount = parseFloat(stateTrx.amount.value);
    if (stateTrx.amount.value != "" && amount >= 2) {
      return false;
    } else {
      return true;
    }
  };

  //CONTROLADOR DE LAS PAGINAS
  const handleScreenControl = () => {
    return {
      fw: !errorTrx ? 9 : -1
    };
  }

  // CLOSE ALERT MESSAGE
  const handleCloseAlert = () => {
    setCookies("exit", false);
    setShowAlert(false)
  };
  const handleConfirmAlert = () => {
    setCookies("closeSesion", true);
    //BORRO LA SESION LOS DATOS DE LA TIENDA
    dispatch(setPos({ value: "", error: true }));
    dispatch(setIdStore({ value: "", error: true }));
    dispatch(setGroup({value: "", error: true }));
    dispatch(setStoreName({ value: "", error: true }));
    dispatch(setCountrySrore({value: "", error: true }));
    dispatch(setCurrencyStore({ value: "", error: true }));

    //CLEAR COOKIES
    removeCookie("login");
    removeCookie("otpTime");
    removeCookie("procedure");
    removeCookie("Store");
    removeCookie("exit");
    setCookies("Store", null);

    //SALGO DE LA INTERFAZ
    dispatch(jump({ current: 0, direction: "backward" }))
    //CLOSE ALERT
    setShowCloseAlert(false)
  };

  return (
    <Fragment>
      <div style={{ marginBottom: "-6em" }}></div>
      {/* SELECT ACTION ALERT */}
      {cookies.exit==true && (
        <AlertSelectBox
          message={`¿Seguro que deseas salir del comercio?`}
          titulo={"Cerrar Sesión"}
          onCancel={handleCloseAlert}
          onConfirm={handleConfirmAlert}
        />
      )}
      
      {/* VIEW ALERT RESPONSE */}
      {showAlert && (
        <AlertBox
          message={`${alertMessage}`}
          type={alertType}
          title={alertTitle}
          onClose={handleCloseAlert}
        />
      )}
      
      {/* ACCOUNT COMPONENT */}
      <InfoTransaction
        trx={stateTrx}
        user={user}
        handleScreenControl={handleScreenControl}
        changeButtonState={changeButtonState}
        submitTransaction={submitTransaction}
      >       
      </InfoTransaction>

      <FloatingButton path="menu"></FloatingButton>
    </Fragment>
  );
};
